import React, { useState } from "react";
import Styles from "./Navbar.module.css";
import { ReactComponent as UpMark } from "../../assets/images/UpMark.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/Slices/authSlice";

const NavProfile = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.persistedReducer);

  const [listOpen, setListOpen] = useState(false);

  const handleClose = () => {
    setListOpen(false);
  };
  const handleLogout = async () => {
    dispatch(logout());
    localStorage.setItem("OTC_V2_TOKEN", null);
    localStorage.clear();
    sessionStorage.clear();
    handleClose();
    window.location = "/login";
  };

  const handleRoute = (url) => {
    window.location = `${url}`;
    handleClose();
  };

  return (
    // <div>
    //   <div
    //     className={Styles.profileMainContainer}
    //     onClick={() => setListOpen(true)}
    //   >
    //     <AccountCircleIcon style={{ fontSize: "24px" }} />
    //     <span className={Styles.compDIsplayName}>
    //       {data?.user?.user?.userName}
    //     </span>
    //     <KeyboardArrowDownIcon style={{ fontSize: "24px" }} />
    //   </div>
    //   {listOpen && (
    //     <div
    //       className={Styles.user_profile_container}
    //       onMouseLeave={handleClose}
    //     >
    //       <div className={Styles.user_profile_DropdownHeader}>
    //         <UpMark />
    //       </div>
    //       <div className={Styles.user_profile_list_mainCont}>
    //         <div className={Styles.each_list_user}>
    //           <AccountCircleIcon style={{ color: "#34656d" }} />
    //           <div>
    //             <div
    //               className={Styles.section_head}
    //               onClick={() => handleRoute("/profile")}
    //             >
    //               My Account
    //             </div>
    //             <div className={Styles.section_head_title}>
    //               Personalize as required
    //             </div>
    //           </div>
    //         </div>
    //         <div className={Styles.each_list_user}>
    //           <AccountCircleIcon style={{ color: "#34656d" }} />
    //           <div>
    //             <div className={Styles.section_head}>My Documents</div>
    //             <div className={Styles.section_head_title}>
    //               Personalize as required
    //             </div>
    //           </div>
    //         </div>
    //         <div className={Styles.each_list_user} onClick={handleLogout}>
    //           <LogoutIcon style={{ color: "#ff4c5e" }} />
    //           <div style={{ color: "#ff4c5e" }}>
    //             <div className={Styles.section_head_log}>Logout</div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </div>
    <div className={Styles.profileWrapper}>
      {/* 🔥 Trigger */}
      <div
        className={Styles.profileMainContainer}
        onClick={() => setListOpen((prev) => !prev)}
      >
        <AccountCircleIcon className={Styles.profileIcon} />

        <span className={Styles.compDIsplayName}>
          {data?.user?.user?.userName}
        </span>

        <KeyboardArrowDownIcon
          className={`${Styles.arrow} ${listOpen ? Styles.rotate : ""}`}
        />
      </div>

      {/* 🔥 Dropdown */}
      {listOpen && (
        <div
          className={Styles.user_profile_container}
          onMouseLeave={handleClose}
        >
          <div className={Styles.user_profile_DropdownHeader}>
            <UpMark />
          </div>

          <div className={Styles.user_profile_list_mainCont}>
            
            <div
              className={`${Styles.each_list_user} ${Styles.logout_item}`}
              onClick={handleLogout}
            >
              <LogoutIcon className={Styles.logout_icon} />
              <div className={Styles.section_head_log}>Logout</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavProfile;
